import * as React from "react";

function SvgBBiconsNemovitostiCisloListuVlastnictvi(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <defs>
        <style>
          {
            ".BBicons_Nemovitosti_Cislo-listu-vlastnictvi_svg__cls-1{fill-rule:evenodd}"
          }
        </style>
      </defs>
      <g
        id="BBicons_Nemovitosti_Cislo-listu-vlastnictvi_svg__Obecn\xE9_ikony"
        data-name="Obecn\xE9 ikony"
      >
        <g
          id="BBicons_Nemovitosti_Cislo-listu-vlastnictvi_svg__Nemovitosti_-_cislo_listu_vlastnictvi"
          data-name="Nemovitosti - cislo listu vlastnictvi"
        >
          <path
            className="BBicons_Nemovitosti_Cislo-listu-vlastnictvi_svg__cls-1"
            d="M112.05 20.32l-61 .05a8.17 8.17 0 00-8.29 8v143.27a8.16 8.16 0 008.29 8h98.32a7.8 7.8 0 007.9-7.69V64.61a3.94 3.94 0 00-3.95-3.94h-30.55-.07A6.72 6.72 0 01116 54V24.27a3.94 3.94 0 00-3.95-3.95zM89 32.38a3 3 0 012.17.74 2.55 2.55 0 01.77 2 8.05 8.05 0 01-.08 1.11c0 .36-.1.7-.17 1s-.1.52-.12.61l-1 5.08c2.57.06 3.87 1 3.87 3a2.78 2.78 0 01-.94 2.17 4 4 0 01-2.71.81h-1.43l-1.63 7.84h3a3.79 3.79 0 012.71.87 2.9 2.9 0 01.94 2.19 2.79 2.79 0 01-.9 2.2 4 4 0 01-2.74.81h-4.17L85.31 69c-.19 1-.36 1.73-.51 2.26a3.18 3.18 0 01-.89 1.43 2.57 2.57 0 01-1.85.62 3 3 0 01-2.15-.76 2.64 2.64 0 01-.76-2 12.9 12.9 0 01.37-2.76l1-5h-6L73.28 69a13.93 13.93 0 01-1 3.3 2.29 2.29 0 01-2.25 1 3.05 3.05 0 01-2.17-.76 2.64 2.64 0 01-.76-2 7.32 7.32 0 01.15-1.38c.1-.51.17-1 .24-1.38l1-5c-2.49 0-3.73-1-3.73-3a2.8 2.8 0 01.91-2.19 3.93 3.93 0 012.74-.87h1.29l1.53-7.84h-2.81a3.85 3.85 0 01-2.71-.88 3 3 0 010-4.31 4 4 0 012.74-.82h4l1.28-6.19a13.92 13.92 0 01.64-2.44 3 3 0 011-1.35 2.69 2.69 0 011.63-.44 3 3 0 012.19.74 2.62 2.62 0 01.74 2c0 .18-.14 1.08-.44 2.71l-1 5h5.92l1.28-6.19c.18-.93.35-1.66.52-2.24a3.19 3.19 0 01.9-1.47 2.67 2.67 0 011.89-.62zM77.3 48.9l-1.58 7.84h6l1.53-7.84zM100 100c1.39 0 2.51 1.13 3.36 1.9l21.75 20 2.35 2.2c3 2.67-.49 5.59-3.06 3.15L100 104.64l-24.43 22.68c-2.57 2.44-6-.48-3.06-3.15l2.27-2.1 6.12-5.65v-10c0-1.6 0-2.89 1.6-2.89h4c.88 0 1.61 1.29 1.61 2.89v3.43l8.55-7.9c.82-.8 1.94-1.95 3.34-1.95zm0 7.45l24.61 22.72v20.05c0 2.35-2.23 4.24-5 4.24H80.33c-2.75 0-5-1.89-5-4.24v-20.03z"
          />
          <path
            className="BBicons_Nemovitosti_Cislo-listu-vlastnictvi_svg__cls-1"
            d="M123.54 20.46a3.91 3.91 0 00-3 3.84v25a17.55 17.55 0 000 2.27 4.76 4.76 0 001.8 3.5 5 5 0 003.28 1.09h27.53a3.93 3.93 0 003.79-5 .22.22 0 000-.08 4 4 0 00-.22-.76 7.1 7.1 0 00-1.72-2.71l-25.81-25.23a7.66 7.66 0 00-2.57-1.63 4.33 4.33 0 00-1-.27 1.57 1.57 0 00-.29 0 3.87 3.87 0 00-1.79-.02z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgBBiconsNemovitostiCisloListuVlastnictvi;
